import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DroitSimulationModel } from './../03-fin/models/droitsimulation.model';
import { FoyerModel } from './../03-fin/models/calcul/foyer.model';
import { EnfantService } from '../02-declaration-enfant/components/enfant/services/enfant.service';
import { DeclarationModel } from '../01-declaration/models/declaration.model';
import { PageFinModel } from './../03-fin/models/pagefin.model';
import { ConstantePage } from '../constants/constante-page';

import { MappingFluxService } from './../03-fin/services/mapping-flux.service';
import { SimulerPrestationService } from './../03-fin/services/simuler-prestation.service';

@Injectable({
  providedIn: 'root'
})
export class SimulerService {  
  
  declarationModel: DeclarationModel;
  pageFinModel: PageFinModel;
  droitSimulationModel: DroitSimulationModel;

  foyer: FoyerModel;

  nombreEnfantMoinsXXansAvecRevenusSuperieur: number;
  seuilAge: number;
  codePostal : number;   

  constructor(private readonly simulerPrestationService: SimulerPrestationService,
    private readonly enfantService: EnfantService,
    private readonly mappingFluxService: MappingFluxService,
    private readonly router: Router    
  ) {} 
 
 
  /**
    * Traitement appelé à l'initialisation du composant à l'écran : 
    * Récupération du flux correspondant à la saisie dans le session storage
    * Construction du flux à envoyer au service de calcul
    * Récupération de la réponse du calcul dans droitSimulationModel
    * Envoi du tag WA en fonction du résultat récupéré
    * 
    * Note : Les appels sont synchrones (il faut tagguer la page seulement à la récupération du résultat)
    */
   async initEcran() {

    const pagePrecedente: string = ConstantePage.STATS_PAGE_DECLARATION;
    this.declarationModel = JSON.parse(sessionStorage.getItem(pagePrecedente));

    this.foyer = new FoyerModel();
    if (this.declarationModel) {
      this.foyer = this.mappingFluxService.construireFlux(this.declarationModel);
      this.nombreEnfantMoinsXXansAvecRevenusSuperieur = this.enfantService.getNombreEnfantMoinsXXansAvecRevenusSuperieur(this.declarationModel.listeEnfants);
      this.codePostal = this.enfantService.extractionCodePostal(this.declarationModel.logement.localite.codePostal);
      this.seuilAge = this.enfantService.retourneAgeMaxEnfant(this.codePostal.toString());
    }

    // 2 - Appel de prestationalmiddle en passant le foyer en body
    this.droitSimulationModel = await this.simulerPrestationService.simuler(this.foyer);

    // 3
    // Détecter plantage du service simuler 
    // Si pas d'erreur => Afficher la page résultat         

    if (sessionStorage.getItem("erreurSimulateur")=="true") {
      // Si Erreur on reste sur la même page et on affiche la message d'erreur spécifique
      sessionStorage.setItem("erreurSimulateur", "true");
    }else{
      // Renseigner les informations nécessaires à l'écran de FIN
      this.renseignerInfosEcranFin();
    }   
    
  }

  /**
     * initBouchon
     * Permet d'initialiser l'écran en mode bouchon de manière autonome en passant directement sur la page de fin
     * localhos:4200/#fin
     * Modifier dans la methode getDataRequestBouchon() la constante qui pointe sur lefichier de test que l'on souhaite :
     * assets/data/pagefin/.... 2_request_simulateur_couple_enfant_ressources.json par exemple
     */
  async initBouchon() {

    // 0 - Recuperation du flux DeclarationModel (flux de saisie bouchonné)
    this.declarationModel = await this.simulerPrestationService.getDeclarationModelJSON();
           
    this.foyer = new FoyerModel();
    this.foyer = this.mappingFluxService.construireFlux(this.declarationModel);

    
    this.nombreEnfantMoinsXXansAvecRevenusSuperieur = this.enfantService.getNombreEnfantMoinsXXansAvecRevenusSuperieur(this.declarationModel.listeEnfants);
    this.codePostal = this.enfantService.extractionCodePostal(this.declarationModel.logement.localite.codePostal);
    this.seuilAge = this.enfantService.retourneAgeMaxEnfant(this.codePostal.toString());

    // 2 - Appel de prestationalmiddle en passant le foyer en body
    this.droitSimulationModel = await this.simulerPrestationService.simuler(this.foyer);

    // 3
    // Détecter plantage du service simuler 
    // Si pas d'erreur => Afficher la page résultat     

    if (sessionStorage.getItem("erreurSimulateur")=="true") {
      // Si Erreur on reste sur la même page et on affiche la message d'erreur spécifique
      sessionStorage.setItem("erreurSimulateur", "true");
    }else{
      // Renseigner les informations nécessaires à l'écran de FIN
      this.renseignerInfosEcranFin();
    }
   
  }

  renseignerInfosEcranFin() {
    this.pageFinModel = new PageFinModel();
    this.pageFinModel.nombreEnfantMoinsXXansAvecRevenusSuperieur = this.nombreEnfantMoinsXXansAvecRevenusSuperieur;
    this.pageFinModel.codePostal = this.codePostal;
    this.pageFinModel.seuilAge = this.seuilAge;
    this.pageFinModel.montantDroit = this.droitSimulationModel.montantDroit;
    this.pageFinModel.possedeDesDroits = this.droitSimulationModel.possedeDesDroits;

    sessionStorage.setItem("pageFinModel", JSON.stringify(this.pageFinModel));    
    
     // Redirection
     this.router.navigate(['/fin']);
  }

}
